/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import __unplugin_components_0 from '~icons/ep/arrow-left';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66fb1d76"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "GS分成", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 举例：GS分成70%，在\"我的收益\"一栏，GS看到的流水将为实际流水的70%；建议与GS商讨一致后再修改。 ", -1));
const _hoisted_3 = {
  class: "marginR10"
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import UQuestion from '@ultra/share/components/UQuestion/index.vue';
import AddGSModal from './addGSModal.vue';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/modules/app';
import { apiGetGSList, apiDelOrRecoverGS } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['toBind'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      gameInfo
    } = storeToRefs(useAppStore());
    const activeCard = ref('channelList');
    // 控制GS列表和回收站的状态切换
    const currentListType = ref('channel');
    const panes = ref([{
      title: 'GS管理',
      key: 'channelList'
    }]);
    const addOrEditGsRef = ref();
    const handleDelOrRecoverGS = async (status, id) => {
      const res = await apiDelOrRecoverGS({
        id,
        status
      });
      if (res.code === 0) {
        getTableData();
      }
    };
    const emits = __emit;
    const handleClick = (type, data) => {
      if (type === 'recycle') {
        currentListType.value = 'recycle';
        panes.value[0].title = '回收站';
        getTableData();
        return;
      }
      if (type === 'channelManage') {
        currentListType.value = 'channel';
        panes.value[0].title = '渠道管理';
        getTableData();
        return;
      }
      if (type === 'addGS') {
        addOrEditGsRef.value.show({
          type: 'add'
        });
        return;
      }
      if (type === 'editorGS') {
        addOrEditGsRef.value.show({
          type: 'edit',
          data
        });
        return;
      }
      if (type === 'deleteGS') {
        ElMessageBox.confirm('确定删除吗？删除后将清空绑定的所有玩家并放入回收站。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          handleDelOrRecoverGS(1, data.id);
        });
        return;
      }
      if (type === 'delete') {
        ElMessageBox.confirm('确定彻底删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          handleDelOrRecoverGS(3, data.id);
        });
        return;
      }
      if (type === 'recover') {
        handleDelOrRecoverGS(2, data.id);
        return;
      }
      if (type === 'toBind') {
        emits('toBind', data);
      }
    };
    const playerSort = ref('descending');
    const handleSortChange = (column, prop, order) => {
      if (prop === 'player_count') {
        playerSort.value = order;
        getTableData();
      }
    };
    const columnChannel = {
      label: '绑定玩家次数',
      prop: 'player_count',
      width: 180,
      slot: 'player_count',
      sortable: true,
      align: 'right'
    };
    const columnDelete = {
      label: '删除日期',
      prop: 'deleted_at',
      width: 180,
      slot: 'deleted_at'
    };
    const commonColumns = [{
      label: 'GSID',
      prop: 'id',
      width: 100,
      align: 'right'
    }, {
      label: 'GS名称',
      prop: 'name',
      width: 100
    }, {
      label: '管理员手机号',
      prop: 'phone',
      width: 150
    }, {
      label: '备注',
      prop: 'remark',
      width: 150
    }, {
      label: 'GS分成',
      prop: 'rate',
      header: 'channelHeader',
      slot: 'rate',
      width: 150,
      align: 'right'
    }, {
      label: '操作',
      action: true
    }];
    const columns = ref(commonColumns);
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGetGSList({
        game_id: gameInfo.value.Id,
        is_delete: currentListType.value === 'recycle',
        page: current.value,
        page_size: pageSize.value,
        player_count_sort: currentListType.value === 'recycle' ? 0 : playerSort.value === 'ascending' ? 1 : 2
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data.list;
        total.value = res.data.total;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => gameInfo.value, val => {
      if (val) getTableData();
    }, {
      immediate: true,
      deep: true
    });
    watch(() => currentListType.value, val => {
      let temp = JSON.parse(JSON.stringify(commonColumns));
      if (val === 'channel') temp.splice(5, 0, columnChannel);
      if (val === 'recycle') temp.splice(5, 0, columnDelete);
      columns.value = temp;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_i_ep_ArrowLeft = __unplugin_components_0;
      const _component_el_button = __unplugin_components_1;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      const _directive_has = _resolveDirective("has");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: _unref(activeCard),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(activeCard) ? activeCard.value = $event : null),
        panes: _unref(panes)
      }, {
        "left-extra-back": _withCtx(() => [_unref(currentListType) === 'recycle' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "back-btn",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('channelManage'))
        }, [_createVNode(_component_i_ep_ArrowLeft)])) : _createCommentVNode("", true)]),
        extra: _withCtx(() => [_unref(currentListType) === 'channel' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => handleClick('recycle'))
        }, {
          default: _withCtx(() => [_createTextVNode("回收站")]),
          _: 1
        })) : _createCommentVNode("", true), _unref(currentListType) === 'channel' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => handleClick('addGS'))
        }, {
          default: _withCtx(() => [_createTextVNode("添加GS")]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "channelList"
        }, {
          default: _withCtx(() => [_createVNode(UTable, {
            options: _unref(columns),
            "row-key": "id",
            data: _unref(tableData),
            loading: _unref(tableLoading),
            onSortChange: handleSortChange,
            pagination: "",
            total: _unref(total),
            "current-page": _unref(current),
            "page-size": _unref(pageSize),
            onSizeChange: _unref(handleSizeChange),
            onCurrentChange: _unref(handleCurrentChange)
          }, {
            channelHeader: _withCtx(() => [_createElementVNode("div", null, [_hoisted_1, _unref(currentListType) === 'channel' ? (_openBlock(), _createBlock(UQuestion, {
              key: 0
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })) : _createCommentVNode("", true)])]),
            rate: _withCtx(({
              scope
            }) => [_createTextVNode(_toDisplayString(scope.row.rate / 100) + "% ", 1)]),
            deleted_at: _withCtx(({
              scope
            }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.deleted_at)), 1)]),
            player_count: _withCtx(({
              scope
            }) => [_createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.player_count), 1), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('toBind', scope.row.id)
            }, {
              default: _withCtx(() => [_createTextVNode("去绑定")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_has, 'bindManage']])]),
            action: _withCtx(({
              scope
            }) => [_unref(currentListType) === 'channel' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "primary",
              onClick: $event => handleClick('editorGS', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("编辑")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(currentListType) === 'channel' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              link: "",
              type: "danger",
              onClick: $event => handleClick('deleteGS', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(currentListType) === 'recycle' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              link: "",
              type: "primary",
              onClick: $event => handleClick('recover', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("恢复")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(currentListType) === 'recycle' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              link: "",
              type: "danger",
              onClick: $event => handleClick('delete', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("彻底删除")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["options", "data", "loading", "total", "current-page", "page-size", "onSizeChange", "onCurrentChange"])]),
          _: 1
        }), _createVNode(AddGSModal, {
          ref_key: "addOrEditGsRef",
          ref: addOrEditGsRef,
          gid: _unref(gameInfo).Id,
          onOk: getTableData
        }, null, 8, ["gid"])]),
        _: 1
      }, 8, ["modelValue", "panes"]);
    };
  }
});